module.exports = __webpack_public_path__ + "assets/db3cd038bb366aa217bf7ba4b413f861.mp3";